import { Component, Input, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import * as fromBackButton from '@app/root-store/ui/back-button';
import { Observable } from 'rxjs';
import * as fromFreezeBlock from '@app/root-store/ui/freeze-block/freeze-block.selectors';

@Component({
  selector: 'rh-add-news-button',
  templateUrl: './add-news-button.component.html',
  styles: []
})
export class AddNewsButtonComponent implements OnInit {
  @Input() breadcrumbRoutes: Array<{label: string, route: string}> = [];
  public blocked$: Observable<boolean> = this.store$.pipe(select(fromFreezeBlock.selectBlocked));
  constructor(
    private store$: Store<any>
  ) {}

  ngOnInit(): void {
    this.store$.dispatch(fromBackButton.setAddNewsMiddleRoute({
      routes: this.breadcrumbRoutes
    }));
  }
}
